<ndt-advanced-account-settings-view
   [form]="form"
   [account]="account"
   [title]="title"
   [callState]="callState$ | async"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onConfirm()"
></ndt-advanced-account-settings-view>
